import { render } from "./all-bulanan.vue?vue&type=template&id=6d7f6530"
import script from "./all-bulanan.vue?vue&type=script&lang=js"
export * from "./all-bulanan.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__